/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_ImageInputs */



/**
* | output |
* | --- |
* | "Bulk carrier with tugs alongside at sea" |
*
* @param {Home_Why_ImageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_why_image = /** @type {((inputs?: Home_Why_ImageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_ImageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("海上由拖轮协助的散货船")
	return /** @type {LocalizedString} */ ("Bulk carrier with tugs alongside at sea")
});